<div class="d-block position-relative flex-grow-1 full-height">
    <canvas baseChart
            [datasets]="datasets"
            [labels]="dataTitles"
            [options]="chartOptions"
            [plugins]="chartPlugins"
            chartType="bar"
    >
    </canvas>
</div>
